import React from 'react';
import styled from 'fe-styled-components';
import PropTypes from 'prop-types';
import InfoBlob from './InfoBlob';
import theme from 'fe-appdir-lib-theme';

const PROP_TYPES = {
  provider: PropTypes.object,
  // partner: PropTypes.object,
  gaTrackIds: PropTypes.object,
  gaTrackInfo: PropTypes.string,
};

const DEFAULT_PROPS = {
  provider: null,
  // partner: null,
  gaTrackIds: {},
  gaTrackInfo: null,
};

const GreySection = styled.section`
  background-color: ${theme.colorGrey95};
`;

const Container = styled.div`
  margin: 0 auto;
  max-width: 940px;
  padding: 0 15px;
`;

/*
The Container provides a fixed 15px left & right padding.
The space between the two columns, as well as the top & bottom padding are provided by
a combination of margins and paddings on AppContactInfoContainer and InfoBlob, as described below:

Format: [target spacing] = [spacing provided by AppContactInfoContainer] + [spacing provided by InfoBlob]

Mobile:
- top & bottom : 48px = 40px + paddingBasePlusHalf
- between: 36px = 2 * (0 + paddingBasePlusHalf)

Desktop:
- top & bottom: 72px = verticalRhythm3x + 0
- between: 64px = 2 * (0 + spacingXl)
(with negative -margin2x on AppContactInfoContainer to compensate the padding2x)
*/
const AppContactInfoContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding: 40px 0;

  @media only screen and (min-width: ${theme.breakpointMd}) {
    flex-direction: row;
    padding: ${theme.verticalRhythm3x} 0;
    margin: 0 -${theme.spacingXl};
  }
`;

const getLinks = (provider, gaTrackIds, gaTrackInfo) => {
  const links = [];
  provider.websiteUrl ? links.push({
    label: 'Website',
    href: provider.websiteUrl,
    gaTrackId: gaTrackIds.PROVIDER_WEBSITE,
    gaTrackInfo,
  }) : null;
  provider.supportUrl ? links.push({
    label: 'Support',
    href: provider.supportUrl,
    gaTrackId: gaTrackIds.PROVIDER_SUPPORT,
    gaTrackInfo,
  }) : null;
  return links;
}

const AppContactInfo = ({ provider, /*partner*/ gaTrackIds, gaTrackInfo }) => {
  return (
    <GreySection>
      <Container>
        <AppContactInfoContainer>
          {provider && (
            <InfoBlob
              title="Created by"
              thumbnail={provider.iconUrl ? provider.iconUrl : null}
              name={provider.companyName ? provider.companyName : provider.name ? provider.name : ''}
              links={getLinks(provider, gaTrackIds, gaTrackInfo)}
              description={provider.description ? provider.description : ''}
              isCentered
            />
          )}
          {/* {partner && (
            <InfoBlob
              title="Partner Information"
              name={partner.name}
              thumbnail={partner.thumbnail}
              links={[
                {
                  label: 'Website',
                  href: partner.website,
                  gaTrackId: gaTrackIds.PARTNER_WEBSITE,
                  gaTrackInfo,
                },
                {
                  label: "Partner's App Directory",
                  href: partner.externalLink,
                  gaTrackId: gaTrackIds.PARTNER_APP_DIRECTORY,
                  gaTrackInfo,
                },
              ]}
              description={partner.description}
              isCentered={!Boolean(provider)}
            />
          )} */}
        </AppContactInfoContainer>
      </Container>
    </GreySection>
  );
};

AppContactInfo.propTypes = PROP_TYPES;
AppContactInfo.defaultProps = DEFAULT_PROPS;

export default AppContactInfo;
